import { validateTidalLicense } from "../base/index.js";
export * from "valtio";
validateTidalLicense();
//# sourceMappingURL=index.js.map
